import {
        GESTION_OPERATIVA_SOLICITAR_PERITAJE_BEGIN,
        GESTION_OPERATIVA_SOLICITAR_PERITAJE_SUCCESS,
        GESTION_OPERATIVA_SOLICITAR_PERITAJE_FAILURE,
        GESTION_OPERATIVA_SOLICITAR_PERITAJE_DISMISS_ERROR,
        GESTION_OPERATIVA_SOLICITAR_PERITAJE_PATENTE
  } from './constants'
  import { REACT_APP_PERITADOR_API } from '../../../common/config'
  import axios from 'axios'
  
  export function solicitarPeritaje(auto, customer) {
    let { license_plate, quotation_id, business_unit, origin_channel_id } = auto
      return (dispatch, getState) => { // optionally you can have getState as the second argument
        const state = getState()
      if(license_plate){
        dispatch({
          type: GESTION_OPERATIVA_SOLICITAR_PERITAJE_BEGIN,
          data: { license_plate }
        });
  
        if(customer.firstname &&
          customer.lastname &&
          customer.email &&
          customer.phone) {

          // Si no existe originChannel, lo busco
          if(!origin_channel_id){
            const businessUnitName = state.peritador.businessUnits.find(bu => bu.id === business_unit)?.Name;
            // El lowerCase es porque 0Km !== 0km
            origin_channel_id = state.peritador.originChannels.find(oc =>
              String(oc.name).toLowerCase() === String(businessUnitName).toLowerCase()
            )?.id;
          }

          const objSolicitud = {
            serviceDate: new Date(),
            servicePatent: license_plate,
            observations: "",
            email: "",
            client_id: state.gestionOperativa.cliente.id,
            branch_office_id: state.gestionOperativa.sale.branch_office_id,
            car_lot_id: state.gestionOperativa.sale.car_lot_id,
            serviceAddress: {
              address: "",
              location: ""
            },
            customer: {
              identifierType: customer.tipoDoc,
              identifier: customer.documento,
              name: customer.firstname,
              lastname: customer.lastname,
              contact: customer.phone,
              email: customer.email,
            },
            typeRequest: "automatic",
            statusId: "1",
            origin_channel_id,
            origin_request_type: 'Solicitud de venta'
          }

          if (state.gestionOperativa?.sale?.Sale_CRM_Integration?.origin === 'lead') {
            const leadId = state.gestionOperativa.sale.Sale_CRM_Integration.external_id

            objSolicitud.external_id = leadId
            objSolicitud.origin = 'lead'
            objSolicitud.target = 'request'
            objSolicitud.platform = 'asofix'
          }

          const promise = new Promise((resolve, reject) => {
  
            const doRequest = axios.post(REACT_APP_PERITADOR_API+'/requests', objSolicitud)
            doRequest.then(
              (res) => {
                dispatch({
                  type: GESTION_OPERATIVA_SOLICITAR_PERITAJE_SUCCESS,
                  data: { res, license_plate },
                });
                resolve(res);
              },
              // Use rejectHandler as the second argument so that render errors won't be caught.
              (err) => {
                dispatch({
                  type:  GESTION_OPERATIVA_SOLICITAR_PERITAJE_FAILURE,
                  data: { error: err.message, license_plate },
                });
                reject(err);
              },
            );
          });
  
          return promise;
  
        } else {
          dispatch({
            type:   GESTION_OPERATIVA_SOLICITAR_PERITAJE_FAILURE,
            data: { error: "Se deben completar todos los datos del cliente", license_plate },
          });
        }
      } else {
        dispatch({
          type:     GESTION_OPERATIVA_SOLICITAR_PERITAJE_PATENTE,
          data: { error: "Primero ingrese la patente", quotation_id },
        });
      }
    };
  }
  
  // Async action saves request error by default, this method is used to dismiss the error info.
  // If you don't want errors to be saved in Redux store, just ignore this method.
  export function dismissSolicitarPeritajeError() {
    return {
      type: GESTION_OPERATIVA_SOLICITAR_PERITAJE_DISMISS_ERROR,
    };
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case  GESTION_OPERATIVA_SOLICITAR_PERITAJE_BEGIN:
        // Just after a request is sent
        return {
          ...state,
          sale: {
            ...state.sale,
            Taking_cars: state.sale.Taking_cars.map((usado) => {
              if (usado.license_plate === action.data.license_plate) {
                return {
                  ...usado,
                  pendingPeritaje: true,
                  errorPeritaje: null,
                }
              } else {
                return usado
              }
            }),
          },
        };
  
      case  GESTION_OPERATIVA_SOLICITAR_PERITAJE_SUCCESS:
        // The request is success
        return {
          ...state,
          sale: {
            ...state.sale,
            Taking_cars: state.sale.Taking_cars.map((usado) => {
              if (usado.license_plate === action.data.license_plate) {
                return {
                  ...usado,
                  assessed: action.data.res.data.statusId,
                  quotation_id: action.data.res.data.id,
                  pendingPeritaje: false,
                  errorPeritaje: null,
                  requestsId: action.data.res.data.id
                }
              } else {
                return usado
              }
            })
          }
        };
  
      case  GESTION_OPERATIVA_SOLICITAR_PERITAJE_PATENTE:
        // The request is failed
        return {
          ...state,
          sale: {
            ...state.sale,          
            Taking_cars: state.sale.Taking_cars.map((usado) => {
              if (usado.quotation_id === action.data.quotation_id) {
                return {
                  ...usado,
                  pendingPeritaje: false,
                  errorPeritaje: action.data.error,
                }
              } else {
                return usado
              }
            }),
          }
        };
  
      case  GESTION_OPERATIVA_SOLICITAR_PERITAJE_FAILURE:
        // The request is failed
        return {
          ...state,
          sale: {
            ...state.sale, 
            Taking_cars: state.sale.Taking_cars.map((usado) => {
              if (usado.license_plate === action.data.license_plate) {
                return {
                  ...usado,
                  pendingPeritaje: false,
                  errorPeritaje: action.data.error,
                }
              } else {
                return usado
              }
            }),
          },
        };
  
      case  GESTION_OPERATIVA_SOLICITAR_PERITAJE_DISMISS_ERROR:
        // Dismiss the request failure error
        return {
          ...state,
          solicitarPeritajeError: null,
        };
  
      default:
        return state;
    }
  }

